module.exports = __webpack_public_path__ + "img/verify-for-admin-in-portal-th.067a5dc.png";